import { useEffect } from 'react'
import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom'
import { reportError } from '@/lib/monitoring'
import { DsEmptyState } from '@/ds'

export function RouteErrorPage() {
  const error = useRouteError()
  useEffect(() => {
    if (!isRouteErrorResponse(error)) reportError(error, { where: 'route-error-boundary' })
  }, [error])
  const title = isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : 'Something went wrong'
  const detail = isRouteErrorResponse(error) ? null : error instanceof Error ? error.message : null
  return <ErrorState title={title} body={detail ?? 'The page could not be shown. Try again or go back home.'} />
}

export function ErrorState({ title, body }: { title: string; body: string }) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-background px-gutter">
      <DsEmptyState.Error title={title} description={body} />
      <Link to="/" className="text-small-strong text-link underline-offset-4 hover:underline">
        Go to home
      </Link>
    </div>
  )
}
